<template>
    <header class="header">
        <!-- 面包屑具体内容部分 -->
        <a-breadcrumb>
            <a-breadcrumb-item v-for="item in breadNameList" :key="item.id">{{ item.name }}</a-breadcrumb-item>
        </a-breadcrumb>
        <!-- 收藏icon -->
        <!-- <div v-if="breadNameList.length">
            <a-icon type="star" :theme="favourite ? 'filled' : 'outlined'" @click="addToFavourite()" class="header-icon" />
        </div> -->
    </header>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapGetters: userMapGetters } = createNamespacedHelpers("user");
export default {
    name: "FGBreadHead",
    computed: {
        ...userMapGetters(["getUserInfo", "getUserMenus"])
    },
    data() {
        return {
            favourite: false, //是否收藏
            originPath: "", //当前路径
            treeData: [], //菜单栏data
            breadNameList: [] //面包屑层级数组
        };
    },
    watch: {
        $route: {
            /**
             * 监听路由，获取页面当前路径
             */
            handler(newVal) {
                this.originPath = newVal.fullPath;
            },
            deep: true,
            immediate: true
        },

        getUserMenus: {
            /**
             * 获取菜单栏tree数据
             */
            handler(newVal) {
                this.treeData = newVal;
                /**
                 * 递归遍历菜单栏，寻找到最深层次的子路径，记录下所有的父级节点
                 */
                this.breadNameList = this.treeFindPath(newVal, (data) => data.fun_entry === this.originPath);
            },
            deep: true,
            immediate: true
        }
    },
    methods: {
        //是否收藏
        addToFavourite() {
            this.favourite = !this.favourite; //收藏与否，取反

            /**
             * 递归获取到当前子菜单栏的ID
             */
            this.treeFindPath(this.treeData, (data) => data.fun_entry === this.originPath);
            // let nodeArray = this.treeFindPath(this.treeData, (data) => data.fun_entry === this.originPath);
            // console.log(this.favourite === true ? "收藏" : "取消", nodeArray[nodeArray.length - 1].id); //当前菜单ID
        },

        /**
         * 递归遍历节点，寻找到最深节点
         * 可以遍历所有节点
         * 递归遍历菜单栏，寻找到最深层次的子路径，记录下所有的父级节点
         */
        treeFindPath(tree, func, path = []) {
            if (!tree) return [];
            for (const data of tree) {
                /**
                 * 推入父节点数据
                 * 此处可自定义数据记录字段名
                 * 按需改变
                 */
                let obj = {
                    name: data.menu_name, //自定义
                    id: data.id //自定义
                };
                path.push(obj);
                if (func(data)) return path;
                if (data.children) {
                    const findChildren = this.treeFindPath(data.children, func, path);
                    if (findChildren.length) return findChildren;
                }
                path.pop();
            }
            return [];
        }
    }
};
</script>

<style lang="scss" scoped>
.header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 10px 10px 5px 10px;
    font-size: 20px;
    line-height: 20px;

    .header-icon {
        cursor: pointer;
        display: inline-block;
    }
}
</style>
